import { render, staticRenderFns } from "./loan_installment.vue?vue&type=template&id=4f5f185b"
import script from "./loan_installment.vue?vue&type=script&lang=js"
export * from "./loan_installment.vue?vue&type=script&lang=js"
import style0 from "./loan_installment.vue?vue&type=style&index=0&id=4f5f185b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports